import styled from 'styled-components';
import { fadeIn } from '../../../__core/Themes/Animations';

export const SearchSection = styled.section<{ visible: boolean }>`
  background-color: ${({ theme }) => theme.UI_COLORS.background};
  color: ${({ theme }) => theme.UI_COLORS.secondary};
  position: absolute;
  width: 100%;
  box-shadow: rgba(0, 0, 0, 0.06) 0 2px 3px, rgba(0, 0, 0, 0.05) 0 1px 0;
  z-index: 8;
  height: ${({ visible }) => (visible ? 'calc(100vh - 60px)' : 'auto')};
  overflow-y: auto;
`;

export const SearchContainer = styled.div`
  margin: 0 auto;
  max-width: 820px;
  padding: 4rem 0;

  .search-items {
    padding: 0 1rem;
  }

  .search-not-found {
    padding: 0 1rem;
    font-weight: bold;
  }

  @media (${({ theme }) => theme.MEDIA_MIN.tablet}) {
    padding: 4rem 2rem;
    .search-items {
      padding: 0;
    }
  }
`;

export const SearchHeader = styled.div`
  padding: 0 2rem;
  position: relative;
  & > h1 {
    font-size: ${({ theme }) => theme.TYPOGRAPHY.bodyText.fontSize};
    font-weight: ${({ theme }) => theme.TYPOGRAPHY.h1.fontWeight};
    margin-bottom: 1rem;
  }

  @media (${({ theme }) => theme.MEDIA_MIN.tablet}) {
    & > h1 {
      font-size: ${({ theme }) => theme.TYPOGRAPHY.h1.fontSize};
    }
  }
`;

export const SearchFilters = styled.div`
  padding: 1.5rem 0;
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid ${({ theme }) => theme.UI_COLORS.main_gray};
  border-top: 1px solid ${({ theme }) => theme.UI_COLORS.main_gray};
  margin-bottom: 1rem;

  & > .label {
    padding-right: 1rem;
    user-select: none;
    min-width: 7rem;
  }

  @media (${({ theme }) => theme.MEDIA_MIN.tablet}) {
    flex-direction: row;
    align-items: center;
  }
`;

export const FiltersGroup = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;

  input,
  label {
    cursor: pointer;
    font-size: ${({ theme }) => theme.TYPOGRAPHY.bodyTextSmall.fontSize};
    user-select: none;
  }

  & > .inactive {
    color: ${({ theme }) => theme.UI_COLORS.medium_gray};
  }

  & > .all-filters-active {
    input,
    label {
      cursor: not-allowed;
    }
  }

  & > .filter-input {
    margin: 0 1.5rem;
    display: flex;
    align-items: center;

    input {
      margin-right: 1rem;
    }
  }

  @media (${({ theme }) => theme.MEDIA_MIN.tablet}) {
    flex-direction: row;
    align-items: center;
    label {
      cursor: pointer;
      font-size: ${({ theme }) => theme.TYPOGRAPHY.bodyText.fontSize};
    }
  }
`;

export const MaterialGroup = styled.div`
  .material-group-label {
    padding-top: 2rem;
    padding-left: 2rem;
    font-size: ${({ theme }) => theme.TYPOGRAPHY.bodyTextSmall.fontSize};
    font-weight: ${({ theme }) => theme.TYPOGRAPHY.bodyTextSmall.fontWeight};
  }
`;

export const MaterialItem = styled.div`
  padding: 1.5rem 2rem;
  border-radius: 6px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
  background-color: ${({ theme }) => theme.UI_COLORS.light};
  transition: box-shadow 0.3s ease-out;
  text-decoration: none;
  animation: ${fadeIn} 0.5s;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 2rem 0;

  .material-label {
    display: flex;
    align-items: center;
    color: ${({ theme }) => theme.UI_COLORS.secondary};
    font-size: ${({ theme }) => theme.TYPOGRAPHY.bodyText.fontSize};

    svg {
      margin-right: 1.5rem;
      height: 2rem;
      width: 2rem;
      min-width: 2rem;
    }
  }

  .material-label-text {
    display: flex;
    flex-direction: column;
  }

  .material-label-header {
    font-size: ${({ theme }) => theme.TYPOGRAPHY.headerLabel.fontSize};
    font-weight: ${({ theme }) => theme.TYPOGRAPHY.headerLabel.fontWeight};
    color: ${({ theme }) => theme.UI_COLORS.medium_gray};
    margin-bottom: 0.4rem;
    svg {
      margin-left: 0.2rem;
      margin-right: 0.2rem;
      height: 1rem;
      width: 1rem;
      min-width: 1rem;
    }
  }

  &:hover {
    box-shadow: rgba(0, 0, 0, 0.35) 0 5px 10px;
    cursor: pointer;
  }
`;

export const MaterialItemDisabled = styled(MaterialItem)`
  background-color: ${({ theme }) => theme.UI_COLORS.main_gray};
  color: ${({ theme }) => theme.UI_COLORS.medium_gray};

  svg {
    fill: ${({ theme }) => theme.UI_COLORS.medium_gray}!important;
    path {
      fill: ${({ theme }) => theme.UI_COLORS.medium_gray}!important;
    }
  }

  &:hover {
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
    cursor: default;
  }
`;

export const ButtonsSectionForSearch = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  & > button {
    transition: all 0.3s ease-out;

    & > .arrow {
      transform: rotate(90deg);
      display: block;

      & > svg {
        width: 1.6rem;
      }
    }
  }
`;
